import { IPreloadedState } from 'shared/types/redux';

export const selectDatesPopupOpened = (state: IPreloadedState) => state.modals.datesPopupOpened;
